<template>
  <el-dialog
    :title="'相关应用程序(' + classItem.ClassName + ')'"
    :visible="visible"
    @close="onClose"
    @open="onOpen"
    width="70%"
    top="5%"
    append-to-body
    :close-on-click-modal="false"
  >
    <div class="top">
      <div class="left">
        <el-button
          type="primary"
          @click="onCreateClick()"
          v-permission="'dci_version_manage-*'"
        >
          <i class="fas fa-plus"></i> 新增相关应用程序
        </el-button>
      </div>
      <div class="right">
        <el-input
          clearable
          v-model.trim="former['SoftwareName:like']"
          placeholder="请输入应用程序名称"
          @keydown.enter.native="onSubmitQuery"
          style="width: 200px"
        ></el-input
        >&nbsp;
        <el-select
          v-model="former.Tags"
          multiple
          collapse-tags
          placeholder="请选择标签"
          filterable
          clearable
        >
          <el-option
            v-for="(tag, index) in tagList"
            :key="index"
            :label="tag"
            :value="tag"
          ></el-option> </el-select
        >&nbsp;
        <el-button type="primary" @click="onSubmitQuery">
          <i class="fas fa-search"></i>
        </el-button>
      </div>
    </div>
    <el-table :data="itemList" v-loading="loading" style="margin-bottom: 10px">
      <el-table-column
        type="index"
        :index="pager.size * (pager.page - 1) + 1"
        :width="Math.max(48, (pager.size * pager.page).toString().length * 12)"
      />
      <el-table-column prop="SoftwareName" label="应用程序名称" />
      <el-table-column label="标签" width="130">
        <template slot-scope="{ row }">
          <el-tag
            v-for="tag in row.Tags"
            :key="tag"
            style="margin-right: 5px; color: #00b3ca"
            >{{ tag }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column prop="Desc" label="说明" />
      <el-table-column
        prop="NewVersion"
        label="最新版本号"
        width="200"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.NewVersion }}
          <el-tooltip
            content="Top center"
            placement="top"
            effect="light"
            v-if="scope.row.NewUrl !== ''"
          >
            <div slot="content">下载地址:<br />{{ scope.row.NewUrl }}</div>
            <i
              class="fas fa-clone"
              style="color: #67c23a; cursor: pointer"
              v-clipboard="scope.row.NewUrl"
              v-clipboard:success="onSuccess"
              v-clipboard:error="onError"
            ></i>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        prop="NewMD5"
        label="MD5"
        width="50"
        show-overflow-tooltip
        align="center"
      >
        <template slot-scope="scope">
          <el-tooltip
            content="Top center"
            placement="top"
            effect="light"
            v-if="scope.row.NewMD5 !== ''"
          >
            <div slot="content">{{ scope.row.NewMD5 }}</div>
            <el-button
              type="warning"
              circle
              size="mini"
              v-clipboard="scope.row.NewMD5"
              v-clipboard:success="onSuccess"
              v-clipboard:error="onError"
            >
              <i class="fas fas fa-th"></i>
            </el-button>
            <!-- <i class="fas fa-th" style="color: #e6a23c"></i> -->
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="发布日期" width="90">
        <template slot-scope="scope">
          <div v-if="scope.row.NewPublishAt">
            {{ $sys.dateFormat(scope.row.NewPublishAt, "Y-m-d") }}
          </div>
        </template>
      </el-table-column>
      <el-table-column width="180" label="操作">
        <template slot-scope="scope">
          <el-button
            type="primary"
            @click.stop="onEditSoftwareItemClick(scope.row)"
            title="编辑"
            v-permission="'dci_version_manage-*'"
          >
            <i class="fas fa-pencil-alt"></i>
          </el-button>
          <el-button
            type="primary"
            @click.stop="onConfigVersionItem(scope.row)"
            title="相关版本"
          >
            <i class="fas fa-cogs"></i>
          </el-button>
          <el-button
            type="success"
            @click.stop="onDownload(scope.row)"
            title="下载"
            :disabled="scope.row.NewUrl === ''"
          >
            <i class="fas fa-download"></i>
          </el-button>
          <el-button
            type="danger"
            @click.stop="onDeleteItem(scope.row)"
            title="删除"
            v-permission="'dci_version_manage-*'"
          >
            <i class="fas fa-trash-alt"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="clearfix mar-top-10">
      <el-pagination
        class="pull-right"
        @current-change="onChangePage"
        layout="total, prev, pager, next"
        :total="pager.total"
        :current-page="pager.page"
        :page-size="pager.size"
      ></el-pagination>
    </div>
    <div slot="footer">
      <el-button @click="onClose">
        <i class="fas fa-times"></i> 关 闭
      </el-button>
    </div>

    <el-dialog
      :title="(this.softwareItem.ID ? '编辑' : '新增') + '相关应用程序'"
      :visible.sync="softwareVisible"
      append-to-body
      :close-on-click-modal="false"
      @close="onCloseSoftwareItem"
      width="30%"
    >
      <el-form
        ref="softwareItemForm"
        label-width="120px"
        :model="softwareItem"
        :rules="rules"
      >
        <el-form-item label="应用程序名称" prop="SoftwareName">
          <el-input
            v-model.trim="softwareItem.SoftwareName"
            placeholder="请输入应用程序名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="标签" prop="Tags">
          <el-select
            v-model="softwareItem.Tags"
            :multiple-limit="6"
            multiple
            filterable
            allow-create
            default-first-option
            placeholder="请选择或创建标签"
            style="width: 100%"
          >
            <el-option
              v-for="(tag, index) in tagList"
              :key="index"
              :label="tag"
              :value="tag"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="说明" prop="Desc">
          <el-input
            v-model.trim="softwareItem.Desc"
            :autosize="{ minRows: 3 }"
            type="textarea"
            placeholder="请输入说明"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="onCloseSoftwareItem">
          <i class="fas fa-fw fa-times" aria-hidden="true"></i> 取 消
        </el-button>
        <el-button
          type="primary"
          @click="onConfirmSoftwareItem"
          :disabled="submitting"
        >
          <i class="far fa-fw fa-save" aria-hidden="true"></i> 确 定
        </el-button>
      </div>
    </el-dialog>

    <config-version-form
      v-model="softwareItem"
      :visible.sync="configVersionVisible"
      @form:saved="getItemList"
    />
  </el-dialog>
</template>

<script>
import ConfigVersionForm from "./configVersionForm.vue"; //配置相关应用程序
export default {
  components: {
    ConfigVersionForm,
  },
  props: {
    value: Object,
    visible: Boolean,
  },
  data() {
    return {
      classItem: _.clone(this.value), //程序分类
      itemList: [], //相关应用程序
      loading: false,
      pager: {
        total: 0,
        page: 1,
        size: 15,
      },
      former: {
        DciPvSoftwareClassifyID: "",
        "SoftwareName:like": "",
        Tags: [],
      },
      submitting: false,
      softwareVisible: false,
      configVersionVisible: false,
      softwareItem: {
        //应用程序
        ID: "",
        SoftwareName: "", //应用程序名称
        DciPvSoftwareClassifyID: "", //分类id
        Tags: [], //标签
        Desc: "", //描述
      },
      rules: {
        SoftwareName: [
          { required: true, message: "应用程序名称不能为空", trigger: "blur" },
        ],
      },
      tagList: [],
    };
  },
  methods: {
    onOpen() {
      this.classItem = _.cloneDeep(this.value);
      this.getItemList();
      this.getTagList();
    },
    onClose() {
      this.$emit("form:saved", true);
      this.$emit("update:visible", false);
      this.itemList = [];
    },
    //获取程序分类相关应用程序
    getItemList() {
      this.loading = true;
      this.$axios
        .get("dci/pv/software", {
          params: {
            where: {
              DciPvSoftwareClassifyID: this.classItem.ID,
              "SoftwareName:like": this.former["SoftwareName:like"],
            },
            Tags: this.former.Tags,
            ...this.pager,
            with: ["DciPvSoftwareVersions", "DciPvSoftwareClassify"],
            order: ["software_name"],
          },
        })
        .then((response) => {
          this.itemList = response.data.data;
          this.pager = _.pick(response.data, "size", "page", "total");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getTagList() {
      this.$axios
        .get("dci/pv/software/tags")
        .then((response) => {
          this.tagList = response.data;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {});
    },
    //点击新增应用程序按钮
    onCreateClick() {
      this.softwareItem = this.getEmptySoftwareItem();
      this.softwareItem.DciPvSoftwareClassifyID = this.classItem.ID;
      this.softwareVisible = true;
    },
    onCloseSoftwareItem() {
      this.softwareVisible = false;
      this.$refs.softwareItemForm.resetFields();
    },
    //点击编辑应用程序
    onEditSoftwareItemClick(row) {
      this.softwareItem.ID = row.ID;
      this.softwareItem.SoftwareName = row.SoftwareName;
      this.softwareItem.DciPvSoftwareClassifyID = row.DciPvSoftwareClassifyID;
      this.softwareItem.Tags = row.Tags;
      this.softwareItem.Desc = row.Desc;
      this.softwareVisible = true;
    },
    //确认新增/保存应用程序
    onConfirmSoftwareItem() {
      this.$refs.softwareItemForm.validate((valid) => {
        if (!valid) {
          return;
        }
        this.submitting = true;
        this.$emit("input", this.softwareItem);
        const itemData = { ...this.softwareItem };
        // 保存的操作
        this.$axios
          .request({
            url: this.softwareItem.ID
              ? `dci/pv/software/${itemData.ID}`
              : "dci/pv/software",
            method: itemData.ID ? "put" : "post",
            data: itemData,
          })
          .then(() => {
            this.$message.success(itemData.ID ? "编辑成功" : "新增成功");
            this.submitting = false;
            this.softwareVisible = false;
            this.getItemList();
            this.getTagList();
          })
          .catch(({ response }) => {
            this.$sys.alarmResponse(response);
            this.submitting = false;
          });
      });
    },
    getEmptySoftwareItem() {
      return {};
    },

    //配置相关版本
    onConfigVersionItem(row) {
      this.softwareItem = row;
      this.configVersionVisible = true;
    },

    //下载
    async onDownload(row) {
      const { data } = await this.$axios({
        url: row.NewUrl,
        responseType: "blob",
        headers: {
          "Access-Control-Allow-Origin": "*",
        },
      });
      const blob = new Blob([data], {
        type: "application/*;chartset=UTF-8",
      });
      const a = document.createElement("a");
      const url = window.URL.createObjectURL(blob);
      let filename = row.NewVersion;
      if (row.NewUrl.indexOf("/") !== -1) {
        const arr = row.NewUrl.split("/");
        filename = arr[arr.length - 1];
      }

      a.href = url;
      a.download = filename;
      a.click();
      window.URL.revokeObjectURL(url);
    },

    //删除相关应用程序
    onDeleteItem(row) {
      this.$confirm("确定要删除此应用程序吗？", "提示")
        .then(() => this.$axios.delete(`dci/pv/software/${row.ID}`))
        .then(() => {
          this.getItemList();
          this.$message.success("成功删除");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
    },

    onSubmitQuery() {
      this.pager.page = 1;
      this.getItemList();
    },
    onChangePage(page) {
      this.pager.page = page;
      this.getItemList();
    },

    onSuccess() {
      this.$message.success("复制成功");
    },
    onError() {
      this.$message.success("复制失败");
    },
  },
};
</script>
<style lang="scss" scoped>
.top {
  text-align: right;
  background-color: #f5f7fa;
  height: 30px;
  padding: 15px 20px 10px 20px;
  margin: -20px -20px 10px -20px;
}
.left {
  float: left;
  text-align: left;
  width: 100px;
  background-color: #f5f7fa;
}
.right {
  float: right;
  text-align: right;
  width: 80%;
}
</style>

